(function () {
    'use strict';

    angular.module("imApp").factory("productionRoutingsService", [function () {
        let service = {};

        return service;
    }]);
})();
